import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { AddressAutocomplete } from '../AddressAutocomplete'
import { useAppUrl } from '../../../utils/appUrl'
import { checkoutSchema } from '../schema'
import { TextFormField } from '../components'
import { monoButtonSx, monoTinyLabelSx } from '../styles'
import type { CheckoutForm } from '../useCheckoutForm'
import { setFieldError } from '../utils'

type Props = { form: CheckoutForm }

const gridTwo = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  gap: '12px',
}

export const BusinessContactStep: React.FC<Props> = ({ form }) => {
  const appUrl = useAppUrl()
  return (
    <>
      <Button
        component="a"
        href={appUrl}
        target="_blank"
        rel="noreferrer"
        variant="contained"
        color="secondary"
        fullWidth
        sx={[monoButtonSx, { fontSize: 11 }]}
      >
        Already a Qwick user? Log in to post now
      </Button>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, my: 0.5 }}>
        <Box
          sx={{ flex: 1, height: '1px', backgroundColor: 'neutral.lightGray' }}
        />
        <Typography sx={monoTinyLabelSx}>OR</Typography>
        <Box
          sx={{ flex: 1, height: '1px', backgroundColor: 'neutral.lightGray' }}
        />
      </Box>

      <Box sx={gridTwo}>
        <TextFormField
          form={form}
          name="firstName"
          id="first-name"
          label="First Name"
          placeholder="Jane"
          autoComplete="given-name"
        />
        <TextFormField
          form={form}
          name="lastName"
          id="last-name"
          label="Last Name"
          placeholder="Doe"
          autoComplete="family-name"
        />
      </Box>

      <Box sx={gridTwo}>
        <TextFormField
          form={form}
          name="email"
          id="email"
          type="email"
          label="Work Email"
          placeholder="you@company.com"
          autoComplete="email"
        />
        <TextFormField
          form={form}
          name="phone"
          id="phone"
          type="tel"
          label="Phone"
          placeholder="(555) 123-4567"
          autoComplete="tel"
        />
      </Box>

      <TextFormField
        form={form}
        name="company"
        id="company"
        label="Company Name"
        placeholder="Acme Inc."
        autoComplete="organization"
      />

      <form.Field
        name="address"
        validators={{ onChange: checkoutSchema.shape.address }}
      >
        {(field) => (
          <AddressAutocomplete
            id="address"
            label="Company Address"
            placeholder="Acme Inc., 123 Main St, City, State"
            value={field.state.value}
            onChange={(v) => field.handleChange(v)}
            onResolve={(addr) =>
              form.setFieldValue('resolvedAddress', addr ?? null)
            }
            onValidate={(msg) => {
              if (msg) setFieldError(form, 'address', msg)
            }}
            onBlur={field.handleBlur}
            error={!field.state.meta.isValid}
            helperText={field.state.meta.errors[0]?.message}
          />
        )}
      </form.Field>
    </>
  )
}
